import { gql, useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useCurrentUser, useToken } from 'security';
import { useInternalUnreadConversationCount, useProviderUnreadConversationCount } from './useSharedMessaging';

export const MY_UNREAD_CONVERSATION_COUNT_QUERY = gql`
    query myUnreadConversationCount {
        myUnreadConversationCount
    }
`;

export const useMyUnreadConversationCount = () => {
    const token = useToken();
    const currentUser = useCurrentUser();
    const providerGuid = currentUser?.provider?.guid ?? null;
    const [count, setCount] = useState(0);

    const { loading, error, data } = useQuery<{ myUnreadConversationCount: number }>(
        MY_UNREAD_CONVERSATION_COUNT_QUERY,
        { fetchPolicy: 'no-cache' }
    );

    useEffect(() => {
        if (data) {
            setCount(data.myUnreadConversationCount);
        }
    }, [data]);

    const internalLiveCount = useInternalUnreadConversationCount(token, providerGuid === null);
    const providerLiveCount = useProviderUnreadConversationCount(providerGuid, token, providerGuid !== null);
    const liveCount = providerGuid !== null ? providerLiveCount : internalLiveCount;

    useEffect(() => {
        if (liveCount !== null) {
            setCount(liveCount);
        }
    }, [liveCount]);

    return { count, loading, error };
};
